const items = [
  {
    tag: '热梗合集',
    title: '台北娜娜名场面大盘点',
    desc: '整理台北娜娜近期最火爆的直播名场面，经典吃瓜片段一次看过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20abstract%20art%20with%20warm%20pink%20coral%20gradients%2C%20playful%20digital%20shapes%2C%20dynamic%20flowing%20composition%2C%20entertainment%20media%20theme%2C%20modern%20youth%20culture%20aesthetic%2C%20soft%20glowing%20highlights%2C%20clean%20background&width=800&height=500&seq=carousel-01&orientation=landscape',
    alt: '台北娜娜名场面大盘点',
  },
  {
    tag: '热门追踪',
    title: '玩偶姐姐最新动态速递',
    desc: '玩偶姐姐全网内容实时追踪，热门吃瓜娱乐现场一手掌握。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20orange%20abstract%20art%2C%20smooth%20flowing%20curves%2C%20playful%20modern%20design%2C%20digital%20entertainment%20vibe%2C%20soft%20gradient%20background%2C%20youthful%20energetic%20aesthetic%2C%20clean%20minimal%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
    alt: '玩偶姐姐最新动态速递',
  },
  {
    tag: '轻量版精选',
    title: '莫里秀热梗短视频合集',
    desc: '莫里秀轻量版吃瓜短视频精选，搞笑吃瓜瞬间全程高能。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20coral%20and%20rose%20abstract%20geometric%20art%2C%20bubbly%20dynamic%20shapes%2C%20playful%20digital%20composition%2C%20social%20media%20entertainment%20theme%2C%20vibrant%20gradients%2C%20clean%20white%20base%2C%20modern%20youth%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    alt: '莫里秀热梗短视频合集',
  },
  {
    tag: '翻车现场',
    title: '网红直播翻车名场面',
    desc: '吃瓜娱乐现场直击网红直播翻车，搞笑吃瓜瞬间笑到停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20peach%20and%20coral%20abstract%20fluid%20art%2C%20dynamic%20swirling%20shapes%2C%20energetic%20composition%2C%20entertainment%20culture%20theme%2C%20glowing%20accents%2C%20soft%20background%2C%20modern%20playful%20aesthetic&width=800&height=500&seq=carousel-04&orientation=landscape',
    alt: '网红直播翻车名场面',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          全网最热吃瓜专题，每日精选不容错过
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((item, i) => (
            <article key={i} className="group bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}